"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagList = exports.draggableTagList = exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../utils/styleConsts");

var styles = function styles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;outline:none;font-size:", _styleConsts.font.size.large, ";background-color:", color.dark.mars, ";")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1c8qjfa0"
})(styles));

exports.default = _default;
var draggableTagList =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;");
exports.draggableTagList = draggableTagList;
var tagList =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:row;flex-wrap:wrap;");
exports.tagList = tagList;